var configData = {
  configMoney: {
    masked: false,
    prefix: 'R$ ',
    suffix: '',
    thousands: '.',
    decimal: ',',
    precision: 2,
    disableNegative: false,
    disabled: false,
    min: null,
    max: null,
    allowBlank: false,
    minimumNumberOfCharacters: 0,
    shouldRound: true,
    focusOnRight: false,
  },
  tablePagination: {
    enabled: true,
    mode: 'remote',
    dropdownAllowAll: false,
    nextLabel: 'próxima',
    prevLabel: 'anterior',
    rowsPerPageLabel: 'Registros por página',
    ofLabel: 'de',
    pageLabel: 'página', // para modo páginas
    allLabel: 'Todos',
    perPage: 10, // padrão
  }
}

module.exports = configData;
